<template>
  <div class="box">
    <travel-tile v-for="travel in docs" :key="travel._id" :travel="travel"></travel-tile>
  </div>
</template>
<script>
import TravelTile from "./travel-tile";
export default {
  components: { TravelTile },
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["travel/docs"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("travel/index");
  }
};
</script>
